import React, { useState, useEffect, useCallback } from 'react';
import {
  DataGridPro,
  GridToolbarContainer, GridToolbarExport
} from "@mui/x-data-grid-pro";
import { Auth } from 'aws-amplify';
// import { TypographyLink } from '../../ui/styled';
import { paginationSize, ORG_INVOICE_LIST_URL, CBP_ORG_INVOICE_LOCK_URL, dateFormat } from '../../../constants';
import { useDispatch, useSelector } from 'react-redux';
import CommonSearch from '../../common/Search/CommonSearch';
//import { renderCellExpand } from '../../common/GridCell/GridCellExpand';
import { getHeading } from '../../common/commonUtils/commonUtils';
import { getTransportationInvoiceList, lockOrUnlock } from '../CbpInvoiceList/services/cbpInvoiceListApi'
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { commonQueryParams } from '../../../services/QueryParams/QueryParams';
import BackIcon from '../../common/Back/BackIcon';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { ContentTitle, RightGrid } from '../../ui/styled';
import PageHeading from '../../common/Heading/PageHeading';
import moment from 'moment';

const TransportationInvoiceList = () => {
  const [lockDate, setLockDate] = useState(null);
  const [visibleInvIds, setVisibleInvIds] = React.useState('');
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);
  const [searchTransportationInvoiceList, setSearchTransportationInvoiceList] =
    useState('');
  const [
    openTransportationInvoiceDetailDialog,
    setOpenTransportationInvoiceDetailDialog,
  ] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [transportationInvoiceListData, setTransportationInvoiceListData] =
    useState({
      isLoading: false,
      data: [],
      pageSize: 10,
      total: 0,
      page: 1,
      sortModel: '',
      filterModel: {}    
    });

  //const invoiceCbpIds = useSelector((state) => state.invoiceCbpIds);

  const handleLockDate = (e) => setLockDate(e.target.value);

  const handleLock = () => {
    //console.log(visibleInvIds);    
    const url = `${CBP_ORG_INVOICE_LOCK_URL}${visibleInvIds}&date=${lockDate}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    lockOrUnlock({ url, authorization }).then((response) => {
        //if (response.succeeded === true) {
          //console.log(response)
      fetchData();
        //}
    });
  }  
  
  const handleUnlock = () => {
    const url = `${CBP_ORG_INVOICE_LOCK_URL}${visibleInvIds}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    lockOrUnlock({ url, authorization }).then((response) => {
      fetchData();
    });
  }
  


  useEffect(() => {
    if (user?.signInUserSession.accessToken.jwtToken) {
      fetchData();
    }
    getUser().then((userData) => setUser(userData));
  }, [
    user?.signInUserSession.accessToken.jwtToken,
    transportationInvoiceListData.page,
    transportationInvoiceListData.pageSize,
    transportationInvoiceListData.sortModel,
    transportationInvoiceListData.filterModel,
    searchTransportationInvoiceList,
  ]);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  const QuickSearchToolbar = () => {
    return (
      <Box pt={1} sx={{ flexGrow: 1, backgroundColor: '#747070' }}>
        <Grid container spacing={1}>
          <Grid item xs={11}>
            <CommonSearch
              searchText={searchTransportationInvoiceList}
              setSearchText={setSearchTransportationInvoiceList}
            />
          </Grid>
          <Grid item xs={1}>  
            <GridToolbarContainer>
              <GridToolbarExport />
            </GridToolbarContainer>
          </Grid>
        </Grid>    
      </Box>  
    );
  };

  const fetchData = async () => {
    setTransportationInvoiceListData((prveState) => ({ ...prveState, isLoading: true }));
    const url = `${ORG_INVOICE_LIST_URL}?PageNumber=${transportationInvoiceListData.page}&PageSize=${transportationInvoiceListData.pageSize}`;
    const commonParams = commonQueryParams(
      url,
      searchTransportationInvoiceList,
      transportationInvoiceListData
    );
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
   
    const cbpInvoiceList = await getTransportationInvoiceList({
      commonParams,
      authorization,
    });
    //console.log('### cbpInvoiceList');
    //console.log(cbpInvoiceList);
   
    let IDs = '';
    cbpInvoiceList.data.forEach(function (item) {
      IDs += (item.OrgInvID + ','); 
    });
    //console.log('### IDs');
    //console.log(IDs.slice(0, -1));
    setVisibleInvIds(IDs.slice(0, -1));
    setTransportationInvoiceListData((prveState) => ({
      ...prveState,
      ...cbpInvoiceList,
    }));
  };


  const handleSortModelChange = useCallback((sortModel) => {
    setTransportationInvoiceListData((old) => ({
      ...old,
      sortModel: [...sortModel],
    }));
  }, []);

  const handleFilterChange = useCallback((filterModel) => {
    // Here you save the data you need from the filter model
    //console.log(filterModel);
    setTransportationInvoiceListData((old) => ({ ...old, filterModel: {...filterModel} }));
  }, []);  

  //   const updateCBpInvoiceList = (params) => {
  //     const { row } = params;
  //     const cbpInvoiceDetail = {
  //       CbpInvID: row.CbpInvID,
  //       DateFaxed: row.DateFaxedWithOutFormate,
  //       DateRecived: row.DateRecivedWithOutFormate,
  //       Signed: row.Signed,
  //     };
  //     dispatch(getCbpInvoiceDetail(cbpInvoiceDetail));
  //     setOpenBackdrop(true);
  //     setTimeout(() => {
  //       setOpenBackdrop(false);
  //     }, 1000);
  //     setOpenTransportationInvoiceDetailDialog(true);
  //   };

  const columnsData = [
    {
      field: 'OrgInvID',
      headerName: 'Org Invoice Id',
      flex: 1,
    },
    {
      field: 'OrgKey',
      headerName: 'Bill To OrgKey',
      minWidth: 300,
    },
    { field: 'OrgId', headerName: 'Org Id', flex: 1 },
    //{ field: 'OrgInv_SscID', headerName: 'Region', flex: 1 },
    { field: 'OrgInv_MthID', headerName: 'Month', flex: 1 },
    {
      field: 'OrgInvDateSent',
      headerName: 'Date Locked',
      renderCell: (params) => {
      return (
        <Typography>{params.value ? moment(params.value).format(dateFormat) : ''}</Typography>
        );
      },
      flex: 1,
    },
    {
      field: 'OrgInvTrnAmt',
      headerName: 'Transportation Total',
      flex: 1,
      type: 'number',
      valueFormatter: (params) => {
        if (params.value == null) {
          return 0;
        }
        return `${params.value.toLocaleString('en-US', {style: 'currency', currency: 'USD'})}`;
      },
    },
    { 
      field: 'OrgInvAdvMthAmt', 
      headerName: 'Monthly Advance', 
      type: 'number',
      valueFormatter: (params) => {
        if (params.value == null) {
          return 0;
        }
        return `${params.value.toLocaleString('en-US', {style: 'currency', currency: 'USD'})}`;
      },      flex: 1 
    },
    { 
      field: 'OrgInvAmt', 
      headerName: 'Amount', 
      type: 'number',
      valueFormatter: (params) => {
        if (params.value == null) {
          return 0;
        }
        return `${params.value.toLocaleString('en-US', {style: 'currency', currency: 'USD'})}`;
      },      flex: 1 
    },
  ];

  return (
    <>
      {
        /** getHeading('Transportation Invoice List')
         **/ 
      }
      <ContentTitle container>
        <Grid item xs={2}>
          <Box style={{ display: 'flex', alignItems: 'center' }}>
            <BackIcon />
            <PageHeading title='Transportation Invoice List' />
          </Box>
        </Grid>
        <Grid item xs={10}>
          <Stack spacing={1} direction="row">
            <Button variant='contained' onClick={() => handleUnlock()}
            >
              Unlock
            </Button>
            <Button variant='contained' onClick={() => handleLock()}
            >
              Lock
            </Button>
            <Typography variant="h5" style={{ marginTop: '9px' }}>
              Transportation Invoices with this Sent Date
            </Typography>
            <TextField 
              id="lock-date" 
              variant="outlined" 
              type="date"
              onChange={(e) => handleLockDate(e)} 
            />
          </Stack>
        </Grid>
      </ContentTitle>  
      <DataGridPro
        filterMode="server"
        onFilterModelChange={handleFilterChange}      
        getRowId={(row) => row.OrgInvID}
        autoHeight
        getRowHeight={() => 'auto'}
        columns={columnsData}
        rows={transportationInvoiceListData.data}
        pageSize={transportationInvoiceListData.pageSize}
        page={transportationInvoiceListData.page - 1}
        rowCount={transportationInvoiceListData.total}
        paginationMode='server'
        sortingMode='server'
        onPageSizeChange={(newPageSize) =>
          setTransportationInvoiceListData((prveState) => ({
            ...prveState,
            pageSize: newPageSize,
          }))
        }
        onPageChange={(newPage) => {
          setTransportationInvoiceListData((prveState) => ({
            ...prveState,
            page: newPage + 1,
          }));
        }}
        rowsPerPageOptions={paginationSize}
        pagination
        components={{ Toolbar: QuickSearchToolbar }}
        experimentalFeatures={{ newEditingApi: true }}
        onSortModelChange={handleSortModelChange}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
        }
        loading={transportationInvoiceListData.isLoading}
      />
      {/* <CbpInvoiceListDialog
        open={openTransportationInvoiceDetailDialog}
        setOpen={setOpenTransportationInvoiceDetailDialog}
        authToken={user?.signInUserSession.accessToken.jwtToken}
        openBackdrop={openBackdrop}
        fetchData={fetchData}
      /> */}
    </>
  );
};

export default TransportationInvoiceList;
